import { Reveal } from "../Reveal";
import { STEPS } from "../../lib/site";

export const HowItWorks = () => (
  <section id="how" className="bg-[#f8f9fa] py-24 md:py-32" data-testid="how-it-works">
    <div className="max-w-7xl mx-auto px-6 md:px-8">
      <Reveal>
        <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#d90429]">Simple process</span>
        <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-[#0b192c] tracking-tight max-w-2xl">
          Three steps from stressed to boarding.
        </h2>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-3 gap-8 relative">
        <div className="hidden md:block absolute top-8 left-[16%] right-[16%] h-px bg-slate-300" />
        {STEPS.map((step, i) => (
          <Reveal key={step.n} delay={i * 0.12}>
            <div className="relative" data-testid={`step-${i}`}>
              <div className="w-16 h-16 rounded-full bg-white border-2 border-[#0b192c] flex items-center justify-center font-display font-black text-2xl text-[#0b192c] relative z-10">
                {step.n}
              </div>
              <h3 className="mt-6 font-display font-bold text-xl text-[#0b192c]">{step.title}</h3>
              <p className="mt-3 text-slate-600 leading-relaxed">{step.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
